export default __webpack_public_path__ + "static/media/pin 2.99f88c70.svg";